import { cineamoApiClient } from '../../apiClient';
import { UrlQueryParameter, buildUrlQuery } from '../../helpers/url-query-helper';
import { AgeRatingDto } from '../../models/age-rating/AgeRatingDto.types';
import { AgeRatingType } from '../../models/age-rating/AgeRatingType.enum';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { AgeRatingListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

// <------------------------ Age Ratings ------------------------>

type GetAgeRatingsQueryParameter = UrlQueryParameter & {
    countryCodes?: string[];
    type?: AgeRatingType;
};

export function getAgeRatings(
    params?: GetAgeRatingsQueryParameter
): Promise<ApiResponse<AgeRatingListResponse> | null> {
    return cineamoApiClient
        .get<ApiResponse<AgeRatingListResponse>>('/age-ratings' + buildUrlQuery(params))
        .then((res) => res.data)
        .catch(() => {
            return null;
        });
}

// <------------------------ Age Rating ------------------------>

export function getAgeRating(ageRatingId: number): Promise<(ApiResponse<AgeRatingDto> & ApiErrorResponse) | null> {
    return cineamoApiClient
        .get<ApiResponse<AgeRatingDto> & ApiErrorResponse>(`/age-ratings/${ageRatingId}`, {
            credentials: 'same-origin'
        })
        .then((res) => res.data)
        .catch(() => null);
}
